import { gql } from '@apollo/client';

export const MY_MENTORSHIP_NOTIFICATIONS = gql`
  query MyMentorshipNotifications($input: MyMentorshipNotificationsInput) {
    myMentorshipNotifications(input: $input) {
      results {
        event {
          _id
          eventType
          actorUserId
          subjectUserId
          programId
          workspaceId
          resourceType
          resourceId
          title
          message
          deepLink
          metadata
          occurredAt
        }
        isSeen
        isRead
        seenAt
        readAt
      }
      totalCount
      unreadCount
      unseenCount
      programUnreadCounts {
        id
        count
      }
      workspaceUnreadCounts {
        id
        count
      }
      resourceUnreadCounts {
        resourceType
        count
      }
    }
  }
`;

export const MENTORSHIP_NOTIFICATION_ADDED = gql`
  subscription MentorshipNotificationAdded {
    mentorshipNotificationAdded {
      event {
        _id
        eventType
        programId
        workspaceId
        resourceType
        resourceId
        title
        message
        deepLink
        metadata
        occurredAt
      }
      isSeen
      isRead
    }
  }
`;

export const MARK_MENTORSHIP_NOTIFICATIONS_SEEN = gql`
  mutation MarkMentorshipNotificationsSeen($eventIds: [String!]) {
    markMentorshipNotificationsSeen(eventIds: $eventIds) {
      unreadCount
      unseenCount
    }
  }
`;

export const MARK_MENTORSHIP_NOTIFICATIONS_READ = gql`
  mutation MarkMentorshipNotificationsRead($eventIds: [String!]!) {
    markMentorshipNotificationsRead(eventIds: $eventIds) {
      unreadCount
      unseenCount
    }
  }
`;
